export default {
  order: {
    cancel: '取消訂單',
    payment: '立即付款',
    remind: '提醒發貨',
    return: '申請退貨',
    confirm: '確認收貨',
    evaluate: '立即評價',
    logistics: '查看物流',
    noRefund: '未退款',
    refunding: '退款中',
    refundSuccess: '退款成功',
    refundFail: '退款失敗'
  },
  cancelOrderMap: {
    0: "不想要了",
    1: '下錯商品',
    2: '訂單重複',
    3: '無法簽收',
    4: '其他原因',
  },
  "当前余额": "當前餘額",
  "获取验证码": "獲取驗證碼",
  "验证码": "驗證碼",
  "请输入验证码": "請輸入驗證碼",
  "发送": "發送",
  "已发送，请注意查收": "已發送，請注意查收",
  "请选择": "請選擇",
  "备注": "備註",
  "仅能绑定一个收款地址!": "僅能綁定一個收款地址!",
  "绑定成功": "綁定成功",
  "提款地址绑定": "提款地址綁定",
  "电商批发商场": "電商批發商場",
  "请输入完整的支付密码!" : "請輸入完整的支付密碼!",
  "用户未发表评论": "用戶未發表評論",
  '订单': '訂單',
  '下单成功，等待付款': '下單成功，等待付款',
  '下单成功，付款成功': '下單成功，付款成功',
  '已发货，正在运输中': '已發貨，正在運輸中',
  '订单已取消，原因:手动发起取消订单': '預訂單已取消取消，原因:手動發起取消預訂單',
  '订单已取消，原因:超时自动取消订单': '預訂單已取消取消，原因:超時自動取消取消預訂單',
  '商家已确认，已进入备货状态': '商家已確認，已進入備貨狀態',
  '系统发货成功': '供應商發貨成功',
  '订单已签收': '訂單已簽收',
  '发起退款申请': '發起退款申請',
  '退款成功': '退款成功',
  '退款失败': '退款失敗',
  '订单退款成功': '訂單退款成功',
  '订单退款失败': '訂單退款失敗',
  '系统默认好评': '系統默認好評',
  "请输入关键字搜索": '请输入關鍵字搜索',
  '充值金额不能小于1': '格式有误:充值金額不能小於1(包含倆位小數)',
  "猜你喜欢": "猜你喜歡",
  "订单已完成": "訂單已完成",
  "热销推荐": "熱銷推薦",
  "加值": "加值",
  "联系商家": "聯繫商家",
  "提领": "提領",
  "头像选择": "頭像選擇",
  "修改头像": "修改頭像",
  "平台人工发起退款": "平臺人工發起退款",
  subOrder: "提交訂單",
  "-连接已建立-": "-連接已建立-",
  ",才可提币": ",才可提幣",
  "银行卡": "銀行卡",
  "[code]值错误": "[code]值錯誤",
  "[symbol]参数为空": "[symbol]參數為空",
  "goodsFreightTips1": "1、跨境商品運費構成：運費=派送費+長途運費+送貨費",
  "creditQuotaINFO": "100,000至30,000,000，額度靈活， 沒有限制，最長貸款期限一年。",
  "authentic": "100% 正品",
  "homeIconTips1": "100%正品",
  "goodsFreightTips2": "2、如不滿足包郵條件，按實際收取運費產品",
  "goodsFreightTips3": "3、最終解釋權歸平台所有",
  "dayReturns7": "7 天退貨",
  "homeIconTips2": "7天退貨",
  "homeIconTips4": "安全付款",
  "safe": "安全無憂",
  "safePayment": "安全支付",
  "homeDownloadtips4": "商城APP",
  "homeDownloadtips41": "商家APP",
  "keep": "保持",
  "saveQr": "保存二維碼",
  "payPal": "貝寶",
  "coinBlock": "幣種協議",
  "validatorRequire": "必填項不能為空",
  "edit": "編輯",
  "markDefaultAddress": "標記為默認送貨地址",
  "不能为空": "不能為空",
  "cancelOrder2": "不喜歡，不想要",
  "contactUs1": "不想向同學朋友開口借錢，請找我們。",
  "": "",
  "不在交易时段": "不在交易時段",
  "不在可提现时间内": "不在可提現時間內",
  "猜你喜欢": "猜你喜歡",
  "paramError": "參數錯誤",
  "参数错误": "參數錯誤",
  "参数异常，消息获取失败": "參數異常，消息獲取失敗",
  "Operate": "操作",
  "operationSuccess": "操作成功",
  "操作成功": "操作成功",
  "操作类型不能小于0": "操作類型不能小於0",
  "操作类型不是整数": "操作類型不是整數",
  "操作类型为空": "操作類型為空",
  "view": "查看",
  "Checkorder": "查看訂單",
  "logistics": "查看物流",
  "CheckDetails": "查看詳情",
  "lowOpinion": "差評",
  "产品不存在": "產品不存在",
  "产品剩余数量不足": "產品剩餘數量不足",
  "interest": "產生利息",
  "dealSuccess": "成功",
  "successTips": "成功",
  "beSeller": "成為商家",
  "homeBannertips1": "成為商家",
  "承兑商不存在": "承兌商不存在",
  "orderCity": "城市",
  "city": "城市",
  "程序错误": "程序錯誤",
  "持有币种不足": "持有幣種不足",
  "recharge": "充值",
  "rechargeSuccessful": "充值成功",
  "rechargeAddress": "充值地址",
  "rechargeMethod": "充值方式",
  "rechargeRecord": "充值記錄",
  "充值价值不得大于最大限额": "充值價值不得大於最大限額",
  "充值价值不得小于最小限额": "充值價值不得小於最小限額",
  "充值金额不能小于1": "充值金額不能小於1(包含倆位小數)",
  "充值链错误": "充值鏈錯誤",
  "rechargeNum": "充值數量",
  "充值数量不能小于等于0": "充值數量不能小於等於0",
  "rechargeTips": "充值提示：“請如實填寫實際轉賬金額，否則可能導致系統審核不通過，影響充值進度。",
  "dealing": "處理中",
  "processing": "處理中",
  "ship": "船",
  "creditText1": "創業貸款 解決借錢的煩惱",
  "businessloan": "創業貸款申請填寫",
  "存在不同杠杆的持仓单": "存在不同槓桿的持倉單",
  "cancelOrder7": "存在質量問題",
  "存在重复的角色名称": "存在重複的角色名稱",
  "大于最大采购数量": "大於最大採購數量",
  "代理层级错误": "代理層級錯誤",
  "delivered": "待發貨",
  "pendingPayment": "待付款",
  "待付款的订单无法放行": "待付款的訂單無法放行",
  "comment": "待評價",
  "receipt": "待收貨",
  "pending": "待支付",
  "loanHistory": "貸款記錄",
  "rates": "貸款利率",
  "term": "貸款期限",
  "application": "貸款申請",
  "creditWorry": "貸款無憂",
  "orderUnitprice": "單價",
  "当前地址格式错误": "當前地址格式錯誤",
  "当前订单不为待付款状态，无法取消": "當前訂單不為待付款狀態，無法取消",
  "当前还需交易": "當前還需交易",
  "currentRate": "當前匯率",
  "sure": "當然",
  "当日才可申购": "當日才可申購",
  "当日可提现次数不足": "當日可提現次數不足",
  "receivedAddress": "到賬地址",
  "orderAddress": "地址",
  "登陆密码不符合设定": "登陸密碼不符合設定",
  "登陆密码长度不符合设定": "登陸密碼長度不符合設定",
  "login": "登錄",
  "loginIn": "登錄",
  "signIn": "登錄",
  "loginSuccess": "登錄成功",
  "登录过期，请重新登录": "登錄過期，請重新登錄",
  "LoginPassword": "登錄密碼",
  "登录密码必须6-12位": "登錄密碼必須6-12位",
  "登录密码不能为空": "登錄密碼不能為空",
  "登录失败": "登錄失敗",
  "clickUpload": "點擊上傳",
  "phoneNumber": "電話號碼",
  "电话号码已绑定": "電話號碼已綁定",
  "电话号码已绑定其他用户": "電話號碼已綁定其他用戶",
  "email": "電子郵件",
  "shopCollection": "店鋪收藏",
  "订单": "訂單",
  "trackOrder": "訂單",
  "订单不存在": "訂單不存在",
  "orderTrack": "訂單查詢",
  "serialNumber": "訂單號",
  "orderSummary": "訂單匯總",
  "cancelOrderSuccess": "訂單取消成功",
  "订单退款成功": "訂單退款成功",
  "订单退款失败": "訂單退款失敗",
  "orderDetails": "訂單詳情",
  "orderInfo": "訂單信息",
  "订单已签收": "訂單已簽收",
  "订单已取消": "訂單已取消",
  "订单已取消，无法放行": "訂單已取消，無法放行",
  "订单已取消，原因:超时自动取消订单": "訂單已取消，原因:超時自動取消訂單",
  "订单已取消，原因:手动发起取消订单": "訂單已取消，原因:手動發起取消訂單",
  "订单已完成": "訂單已完成",
  "订单已完成，无法放行": "訂單已完成，無法放行",
  "moneyOrderStatus": "訂單狀態",
  "orderPrefix": "訂單總額",
  "subscription": "訂閱",
  "aboutText2": "額度: 100,000至30,000,000，利息低 還款方式靈活，無任何前期費用，線上放款，不打審核電話，信息保密， 當天放款。",
  "additional": "額外的",
  "evaluateOrderSuccess": "發表評價成功",
  "goodsShip": "發貨",
  "发起退款申请": "發起退款申請",
  "send": "發送",
  "发现新版本，请升级到最新版本": "發現新版本，請升級到最新版本",
  "visitStore": "訪問商店",
  "collAccount": "放款方式",
  "loanMethod": "放款方式",
  "classification": "分類",
  "服务器错误": "服務器錯誤",
  "服务器错误(500)": "服務器錯誤(500)",
  "servicePolicy": "服務政策",
  "PaymentOrder": "付款單",
  "uploadTips": "付款證明（上傳付款明細截圖）",
  "copy": "複製",
  "copySuccess": "複製成功",
  "该产品未上架": "該產品未上架",
  "该产品已上市，无法购买": "該產品已上市，無法購買",
  "该订单已取消": "該訂單已取消",
  "remindRepeat": "該訂單已提醒過啦~",
  "该广告剩余数量不足": "該廣告剩餘數量不足",
  "该基金尚未开放购买": "該基金尚未開放購買",
  "该基金尚已封闭": "該基金尚已封閉",
  "productAvailable": "該商品已下架",
  "该邮箱已被订阅": "該郵箱已被訂閱",
  "notOpen": "該支付方式尚未對您所在的地區開放",
  "格式有误:充值金额不能小于1(包含俩位小数)": "格式有誤:充值金額不能小於1(包含倆位小數)",
  "userCenter": "個人中心",
  "Item": "個商品",
  "跟单倍数输入错误": "跟單倍數輸入錯誤",
  "跟单参数输入错误": "跟單參數輸入錯誤",
  "more": "更多",
  "更新提醒": "更新提醒",
  "工作地址不能为空": "工作地址不能為空",
  "homeBannertips2": "共同盈利",
  "orderTotal": "共計",
  "buyHistory": "購買記錄",
  "购买矿机时间不得低于托管订单剩余时间": "購買礦機時間不得低於託管訂單剩餘時間",
  "purchageHistory": "購買歷史",
  "addCartMessageFaild": "購物車已存在該商品",
  "fixedRate": "固定利率",
  "aboutUs": "關於我們",
  "about": "關於我們",
  "followers": "關注",
  "followedSuccess": "關注成功",
  "myFollowedShops": "關注店鋪",
  "广告不存在": "廣告不存在",
  "广告已下架": "廣告已下架",
  "orderSpecification": "規格",
  "countryOf": "國籍",
  "areaCode": "國際區號",
  "orderNation": "國家",
  "nation": "國家",
  "repayment": "還款",
  "repay": "還款方式",
  "reAmount": "還款金額",
  "cycle": "還款週期",
  "loginTips": "還沒有賬號？",
  "noAccount": "還沒有賬號？",
  "NoProductSelected": "還未選擇商品",
  "shipping": "航運",
  "highOpinion": "好評",
  "favorableRate": "好評率",
  "myPraiseRate": "好評率",
  "totalNum": "合計",
  "partner": "合作供應商",
  "partnersTit": "合作夥伴 - 在線借貸平台",
  "BackHome": "回到首頁",
  "or": "或者",
  "freight": "貨運",
  "orderFreight": "貨運",
  "getCoupons": "獲得您更多的優惠券",
  "基金剩余购买金额不足": "基金剩餘購買金額不足",
  "quickLoan": "急速放款",
  "records": "記錄",
  "proceed": "繼續",
  "storeSeachTips3": "家",
  "家庭地址不能为空": "家庭地址不能為空",
  "cancelOrder4": "假冒品牌",
  "price": "價格",
  "piece": "件",
  "transactionPassword": "交易密碼",
  "交易员不存在": "交易員不存在",
  "交易员不能跟随自己": "交易員不能跟隨自己",
  "交易员跟随人数已满": "交易員跟隨人數已滿",
  "交易员未开启带单": "交易員未開啟帶單",
  "交易员无法跟随另一个交易员": "交易員無法跟隨另一個交易員",
  "角色被用户关联，不可删除": "角色被用戶關聯，不可刪除",
  "角色不存在": "角色不存在",
  "receiver": "接收者",
  "financial": "解決您的資金困擾",
  "successLoan": "借款成功",
  "borrow": "借款失敗",
  "loanAgree": "借款協議",
  "amount": "金額",
  "金额不在购买区间": "金額不在購買區間",
  "validatorMaxNumber": "金額超過限制",
  "金额错误": "金額錯誤",
  "validatorChineseAndEnglish": "僅支持中英文,輸入範圍8-64個字符",
  "oldPassword": "舊密碼",
  "旧密码不能为空": "舊密碼不能為空",
  "旧密码不正确": "舊密碼不正確",
  "可平仓合约张数不足": "可平倉合約張數不足",
  "service": "客服",
  "custService": "客戶服務",
  "homeDownloadtips1": "跨境電商批發商場",
  "矿机不存在": "礦機不存在",
  "矿机未解锁，无法购买": "礦機未解鎖，無法購買",
  "From": "來自",
  "历史基金无法购买": "歷史基金無法購買",
  "historySearch": "歷史搜索",
  "payment": "立即付款",
  "buyNow": "立即購買",
  "homeBannerbtn": "立即加入",
  "evaluate": "立即評價",
  "连续输入错误三次，请3分钟后再试": "連續輸入錯誤三次，請3分鐘後再試",
  "contactUs": "聯繫我們",
  "twoPawword": "兩次密碼不匹配",
  "creditQuota": "靈活額度",
  "retailPrice": "零售價",
  "领取成功": "領取成功",
  "pageviews": "瀏覽量",
  "myPageviews": "瀏覽量",
  "buyRules": "買家規則",
  "买入金额需要在区间内": "買入金額需要在區間內",
  "卖方无法取消该订单": "賣方無法取消該訂單",
  "cancelOrder3": "賣家發錯貨",
  "sellerRules": "賣家政策",
  "noDataFound": "沒有找到數據",
  "没有找到用户": "沒有找到用戶",
  "dailyNewArrival": "每日新品上架",
  "pleaseEnterVerificationCode":"请输入验证码",
  "pleaseEnterUsername":"请输入用户名",
  "verificationCode":"验证码",
  "username":"用户名",
  "password": "密碼",
  "getVerificationCode":"获取验证码",
	"tryAgainLater":"秒后再试",
  "密码必须6-12位": "密碼必須為6-12位",
  "密码不能为空": "密碼不能為空",
  "密码不正确": "密碼不正確",
  "wrongPassword": "密碼錯誤次數超過3次, 請明日重試",
  "validatorPassword": "密碼為6-12位數字或字母組成(包含特殊字符)",
  "goodsFreeShipping": "免運費",
  "orderName": "名稱",
  "defaultAddress": "默認地址",
  "noCartTips": "你的購物袋是空的開始購物",
  "notLogin": "你還沒有登錄",
  "unSelectedProduct": "你還未選中商品",
  "evaluationUploading": "你還有正在上傳的圖片,請稍後再試",
  "您当前可分配额度不足": "您當前可分配額度不足",
  "yourEmail": "您的電子郵箱",
  "您没有符合条件的收款方式": "您沒有符合條件的收款方式",
  "您已存在订单": "您已存在訂單",
  "您已购买过体验矿机,不得重复购买": "您已購買過體驗礦機,不得重複購買",
  "photoExample": "拍照示例",
  "homeDownloadtips2": "品牌特賣",
  "Evaluate": "評價",
  "evaluateOrder": "評價曬單",
  "evaluateInput": "評價曬圖",
  "homeDownloadtips5": "蘋果下載",
  "cancelOrder9": "其他原因",
  "businessPhone": "企業電話",
  "businessEmail": "企業郵箱",
  "walletHistory": "錢包歷史",
  "亲属地址不能为空": "親屬地址不能為空",
  "亲属电话不能为空": "親屬電話不能為空",
  "亲属关系不能为空": "親屬關係不能為空",
  "亲属姓名不能为空": "親屬姓名不能為空",
  "empty": "清空",
  "evaluateOrderPlaceholder": "請對評商品做出評價",
  "checkAgreement": "請勾選協議!",
  "请检查网络连接": "請檢查網絡連接",
  "returnDetailTips": "請評價產品",
  "switchLang": "請切換其他語言後查看",
  "请切换其他语言后查看": "請切換其他語言後查看",
  "请上传图片": "請上傳圖片",
  "uploadPhoto": "請上傳照片",
  "请稍后再试": "請稍後再試",
  "请稍后重试": "請稍後重試",
  "pleaseSetLoginPassword": "請設置登錄密碼",
  "pleaseSetMobileNumber": "請設置手機號碼",
  "pleaseEnterPhoneNumer": "請設置手機號碼",
  "plaeseEnterInvitaionCode": "請設置邀請碼",
  "pleaseEnterEmail": "請設置郵箱",
  "enterTips": "請輸入",
  "pleaseInput": "請輸入",
  "validatorFourMoreNumber": "請輸入4位以上純數字",
  "pleaseValidPostCode": "請輸入4位以上的數字",
  "validatorSixNumber": "請輸入6位純數字",
  "请输入充值币种": "請輸入充值幣種",
  "plaseEnterRechargeAddress": "請輸入充值地址",
  "pleaseEnterAmount": "請輸入充值金額",
  "pleaseInputCorrectNumber": "請輸入大於0的數字",
  "pleaseEnterAddress": "請輸入地址",
  "请输入关键字搜索": "請輸入關鍵字搜索",
  "headerSearchTips": "請輸入關鍵字搜索",
  "pleaseEnterOldPassword": "請輸入舊密碼",
  "pleaseEnterPassword": "請輸入密碼",
  "请输入内容": "請輸入內容",
  "plaseeENterConfirmPassword": "請輸入確認密碼",
  "pleaseEnterQuantity": "請輸入數量",
  "请输入搜索关键字": "請輸入搜索關鍵字",
  "withdrawInputTips": "請輸入提幣地址",
  "plaseeEnterNewPassword": "請輸入新密碼",
  "yourName": "請輸入姓名",
  "pleaseEnterAccount": "請輸入賬號",
  "请输入正确的货币数量": "請輸入正確的貨幣數量",
  "请输入正确的金额": "請輸入正確的金額",
  "validatorPhone": "請輸入正確的手機號",
  "pleaseValidPhone": "請輸入正確的手機號碼",
  "请输入正确的数量": "請輸入正確的數量",
  "inpuEmailErro": "請輸入正確的郵箱地址",
  "pleaseValidEmail": "請輸入正確的郵箱地址",
  "validatorEmail": "請輸入正確的郵箱格式",
  "请输入正确的质押金额": "請輸入正確的質押金額",
  "请输入正确的质押天数": "請輸入正確的質押天數",
  "pleaseCorrectAddress": "請輸入正確提幣地址",
  "请填写正确的电话号码": "請填寫正確的電話號碼",
  "请填写正确的验证码": "請填寫正確的驗證碼",
  "mailboxCheck": "請填寫正確的郵箱地址",
  "请填写正确的邮箱地址": "請填寫正確的郵箱地址",
  "请先绑定谷歌验证器": "請先綁定谷歌驗證器",
  "请先添加收款方式": "請先添加收款方式",
  "请先通过高级认证": "請先通過高級認證",
  "cancelOrderTitle": "請選擇訂單取消原因",
  "selectCountry": "請選擇國籍",
  "请选择买卖方式": "請選擇買賣方式",
  "selectPeriod": "請選擇期限",
  "returnOrderTitle": "請選擇退貨理由",
  "请选择正确的币种": "請選擇正確的幣種",
  "请重新登录": "請重新登錄",
  "blockchainNetwork": "區塊鍊網絡",
  "渠道未开通": "渠道未開通",
  "Cancel": "取消",
  "取消": "取消",
  "cancelSuccess": "取消成功",
  "cancelOrder": "取消訂單",
  "cancel": "取消訂單",
  "CancelOrder": "取消訂單",
  "myUnfollow": "取消關注",
  "cancelReason": "取消原因",
  "all": "全部",
  "AllProducts": "全部商品",
  "btnSure": "確定",
  "确认": "確認",
  "entRepay": "確認還款",
  "confirmPayPaw": "確認交易密碼",
  "confirmPassword": "確認密碼",
  "delAllHistoryRecord": "確認刪除全部歷史記錄？",
  "confirm": "確認收貨",
  "date": "日期",
  "scanAndDown": "掃碼二維碼下載APP",
  "homeDownloadtips6": "掃描二維碼下載APP",
  "delete": "刪除",
  "sellerPanelLogin": "商家登錄",
  "merchantSettled": "商家入駐",
  "sellerZone": "成為商家",
  "商家已确认，已进入备货状态": "商家已確認，已進入備貨狀態",
  "commodity": "商品",
  "orderCommodity": "商品",
  "commodityCollection": "商品集合",
  "productDescription": "商品描述",
  "myCommodityCollection": "商品收藏",
  "goodsNumber": "商品數量",
  "goodsShipTips": "商品下單後，24小時內發貨。如下單存在物流管控，訂單可能被延時發貨，請留意訂單物流信息或聯繫客服",
  "productInfo": "商品信息",
  "uploadSuccess": "上傳成功",
  "uploadError": "上傳失敗，請重試",
  "uploading": "上傳中.....",
  "upNew": "上新",
  "previous": "上一步",
  "prevPage": "上一頁",
  "cancelOrder5": "少發、漏發",
  "desc": "設為默認地址",
  "setAsTheDefaultAddress": "設為默認地址",
  "setUp": "設置",
  "setSuccess": "設置成功",
  "setUpPayPaw": "設置交易密碼",
  "setPassword": "設置密碼",
  "申购数量错误": "申購數量錯誤",
  "申请成功": "申請成功",
  "applyLoan": "申請貸款",
  "applicationAmount": "申請金額",
  "noSmaller": "申請金額不能小於",
  "nomax": "申請金額最大不能超過",
  "applicant": "申請人",
  "applicantDate": "申請日期",
  "return": "申請退貨",
  "applicantIn": "申請中",
  "身份证已实名过!": "身份證已實名過!",
  "审核已通过": "審核已通過",
  "审核中": "審核中",
  "state": "省/州/邦",
  "dealFail": "失敗",
  "fail": "失敗",
  "orderTime": "時間",
  "time": "時間",
  "ActualLedger": "實際到賬",
  "actualAccount": "實際賬戶",
  "实名认证未通过，无法进行高级认证": "實名認證未通過，無法進行高級認證",
  "confirmReceiveGoods": "是否確認收到貨",
  "collect": "收藏",
  "collectionSuccess": "收藏成功",
  "wishlist": "收藏商品",
  "cancelOrder6": "收到商品破損",
  "desc5": "收貨地址有誤？聯繫",
  "consigneeName": "收貨人姓名",
  "shippingAddress": "收件地址",
  "pleaseAddShippingAddress": "請先添加收貨地址",
  "收款方输入错误": "收款方輸入錯誤",
  "mobile": "手機號",
  "mobilePhone": "手機號碼",
  "handleFee": "手續費",
  "handlingFee": "手續費",
  '购物车还没有商品': '購物車還沒有商品',
  '去购物': '去購物',
  "home": "首頁",
  "授权状态未成功": "授權狀態未成功",
  "pleaseSetAreaCode": "輸入國家、區號進行搜索",
  "searchCountry": "輸入國家、區號進行搜索",
  "desc3": "輸入交易密碼",
  "desc4": "輸入您的交易密碼",
  "赎回状态异常": "贖回狀態異常",
  "quantity": "數量",
  "orderAmount": "數量",
  "orderQuantity": "數量",
  "inputNum": "數字",
  "orderTax": "稅",
  "orderFee": "稅費",
  "tax": "稅收",
  "delivery": "送貨及取貨",
  "storeSeach": "搜本店",
  "search": "搜索",
  "所选汇率不存在": "所選匯率不存在",
  "allProduct": "所有產品",
  "提币数量不能小于等于0": "提幣數量不能小於等於0",
  "creditText2": "提供創業貸款 資金周轉服務",
  "returnOrderSuccess": "提交成功",
  "Submitareview": "提交評論",
  "submitApplica": "提交申請",
  "提交失败": "提交失敗",
  "提交失败，当前有未处理订单": "提交失敗，當前有未處理訂單",
  "hint": "提示",
  "提示": "提示",
  "withdraw": "提現",
  "提现不得大于限额": "提現不得大於限額",
  "提现不得小于限额": "提現不得小於限額",
  "withdrawSuccess": "訂單提交成功",
  "withdrawAddress": "提現地址",
  "withdrawRecord": "提現記錄",
  "withdrawNum": "提現數量",
  "tipsRemindsSuccess": "提醒成功",
  "remindSuccess": "提醒成功",
  "RemindShip": "提醒發貨",
  "remind": "提醒發貨",
  "remindTitle": "提醒發貨",
  "tipsRemindsText": "提醒發貨後，商家會收到提醒",
  "remindContent": "提醒發貨後，商家會收到提醒, 只能提醒1次喲~",
  "tipsRemindsMerchant": "提醒商家",
  "days": "天",
  "addCartMessage": "添加到購物車成功",
  "addAddress": "添加地址",
  "addAddressOrModifyAddress": "添加地址/修改地址",
  "addCart": "添加購物車",
  "图片不得大于10M": "圖片不得大於10M",
  "图片不得大于2M": "圖片不得大於2M",
  "图片大小不能超过2M！": "圖片大小不能超過2M！",
  "图片上传失败": "圖片上傳失敗",
  "recommend": "推薦",
  "recommendedProducts": "推薦產品",
  "recommendedStore": "推薦店鋪",
  "推荐码不正确": "推薦碼不正確",
  "推荐人无权限推荐": "推薦人無權限推薦",
  "推荐商品": "推薦商品",
  "logout": "退出",
  "returnsAndEx": "退貨和換貨",
  "returnAmount": "退貨金額",
  "returnRemark": "退貨說明",
  "returnPolicy": "退貨政策",
  "Refund": "退款",
  "refund": "退款/售後",
  "退款成功": "退款成功",
  "refundSuccessfully": "退款成功",
  "refundSuccess": "退款成功",
  "returnReason": "退款理由",
  "returnApply": "退款申請",
  "退款失败": "退款失敗",
  "refundFail": "退款失敗",
  "refundInstructions": "退款說明",
  "refunding": "退款中",
  "mastercard": "萬事達卡",
  "EsShop": "網店",
  "ForgotPassword": "忘記密碼？",
  "委托数量(张)必填": "委託數量(張)必填",
  "委托数量(张)不能小于等于0": "委託數量(張)不能小於等於0",
  "foryourmoney": "為你解決資金緊張，無處借錢，不好意思向朋友開口借錢等貸款難題，全程專業人員 服務，隨時解答你的疑惑不解，我們的目標是讓每一筆貸款都透明化，讓客戶快捷放心的使用。",
  "storeSeachTips1": "為您找到",
  "未绑定谷歌验证器": "未綁定谷歌驗證器",
  "未绑定手机号": "未綁定手機號",
  "未绑定邮箱": "未綁定郵箱",
  "未发现授权记录": "未發現授權記錄",
  "notQua": "未滿足資質條件",
  "ShippingAddressNotSet": "未設置收貨地址",
  "未实名认证，是否认证？": "未實名認證，是否認證？",
  "cancelOrder1": "未收到貨",
  "未授权访问": "未授權訪問",
  "noRefund": "未退款",
  "未找到符合条件的匹配订单": "未找到符合條件的匹配訂單",
  "未找到匹配的收益记录": "未找到匹配的收益記錄",
  "mine": "我的",
  "myloan": "我的貸款",
  "myOrder": "我的訂單",
  "myCart": "我的購物車",
  "我的购物车": "我的購物車",
  "myPurse": "我的錢包",
  "myAccount": "我的帳戶",
  "aboutText1": "我們致力於貸款金融服務，基於“客戶至上”的經營理念，以解決客戶資金周轉問題為使命，公司從成立至今，已幫助無數留客戶解決資金周轉問題。",
  "readAndAgree": "我已閱讀並同意",
  "safeInfo": "無抵押貸款，無需押金，不打回訪電話， 這本就是一件私密的事。",
  "无权限": "無權限",
  "无效的UID": "無效的UID",
  "item": "物品",
  "系统参数错误": "系統參數錯誤",
  "系统存在相同[系统登录名]！": "系統存在相同[系統登錄名]！",
  "系统错误，请稍后重试": "系統錯誤，請稍後重試",
  "系统发货成功": "系統發貨成功",
  "系统默认好评": "系統默認好評",
  "defaultRate": "系統默認好評",
  "checkout": "下單",
  "下单不能小于最小金额限制": "下單不能小於最小金額限制",
  "下单成功，等待付款": "下單成功，等待付款",
  "下单成功，付款成功": "下單成功，付款成功",
  "buyTips": "下單後，24小時內發貨。以下訂單受物流控制，可能會延遲發貨。請關注物流信息或聯繫客服。",
  "nextPage": "下一頁",
  "stateMent": "現代奴隸聲明",
  "storeSeachTips2": "相關的店鋪",
  "address": "詳細地址",
  "items": "項目",
  "browse": "銷量",
  "sold": "銷售量",
  "sales": "銷售量",
  "校验IP不合法": "校驗IP不合法",
  "new": "新的",
  "newPassword": "新密碼",
  "新密码不能为空": "新密碼不能為空",
  "新密码不一致": "新密碼不一致",
  "新密码确认不能为空": "新密碼確認不能為空",
  "news": "新聞資訊",
  "addNewAddress": "新增地址",
  "creditTit": "信貸服務",
  "Information": "信息",
  "行情获取异常，稍后再试": "行情獲取異常，稍後再試",
  "modifyAddress": "修改地址",
  "handlingfee": "需要手續費",
  "Opt": "選擇",
  "selectDeliveryAddress": "選擇送貨地址",
  "验证类型不能为空": "驗證類型不能為空",
  "验证码不能为空": "驗證碼不能為空",
  "验证码不正确": "驗證碼不正確",
  "验证码错误": "驗證碼錯誤",
  "vcodeFail": "驗證失敗,請重試",
  "vcodePass": "驗證通過!",
  "invitationCode": "邀請碼",
  "页码不能小于等于0": "頁碼不能小於等於0",
  "页码不是整数": "頁碼不是整數",
  "dashboard": "儀表板",
  "loaned": "已貸款",
  "loanDays": "已貸款天數",
  "已发货，正在运输中": "已發貨，正在運輸中",
  "followed": "已關注",
  "repaid": "已還款",
  "已领取": "已領取",
  "rated": "已評價",
  "cancelled": "已取消",
  "confirmed": "已確認",
  "harvested": "已收貨",
  "mySold": "已售",
  "overdue": "已逾期",
  "privacyPolicy": "隱私政策",
  "用户不存在": "用戶不存在",
  "用户名必须由数字和英文字母组成": "用戶名必須由數字和英文字母組成",
  "用户名不存在": "用戶名不存在",
  "用户名不符合设定": "用戶名不符合要求",
  "用户名不能为空": "用戶名不能為空",
  "用户名参数为空": "用戶名參數為空",
  "用户名重复": "用戶名重複",
  "userEvaluation": "用戶評價",
  "用户剩余数量不足": "用戶剩餘數量不足",
  "用户未发表评论": "用戶未發表評論",
  "用户已跟随交易员": "用戶已跟隨交易員",
  "user_Center": "用戶中心",
  "userReg": "用戶註冊",
  "postCode": "郵編",
  "orderEmail": "郵箱",
  "邮箱已绑定": "郵箱已綁定",
  "邮箱已绑定其他用户": "郵箱已綁定其他用戶",
  "orderPostCode": "郵政編碼",
  "hasImage": "有圖",
  "Balance": "餘額",
  "balance": "餘額（USDT）",
  "余额不足": "餘額不足",
  "balanceNot": "餘額不足，請充值",
  "cancelOrder8": "與商家協商一致退款",
  "expectedArrival": "預計到貨",
  "esRepayment": "預計還款",
  "estirepay": "預計還款",
  "originPrice": "原價",
  "deliveryFee": "運費",
  "goodsFreight": "運費",
  "shippingDiscounts": "運費折扣",
  "homeIconTips3": "運費折扣",
  "desc6": "再次輸入您的交易密碼",
  "rebuy": "再來一單",
  "onlineService": "在線服務",
  "customeService": "在線客服",
  "helpLine": "在線客服",
  "onlineApplin": "在線申請",
  "暂无店铺": "暫無店鋪",
  "noComments": "暫無評價",
  "noData": "暫無數據",
  "帐户异常需要进行C3认证，请联系在线客服。": "帳戶異常需要進行C3認證，請聯繫在線客服。",
  "account": "賬戶",
  "accountBalance": "賬戶餘額",
  "accountB": "賬戶餘額",
  "accountReview": "賬戶總覽",
  "Recruitment": "招賢納士",
  "找不到用户": "找不到用戶",
  "searchTips": "找貨源/商品/供應商/求購",
  "discount": "折扣",
  "homeDownloadtips3": "折扣不停",
  "discounted": "折扣商品",
  "actualName": "真實姓名",
  "passPortImg": "證件號碼/護照號碼",
  "uploadId": "證件照/護照上傳",
  "Payment": "支付",
  "pay": "支付",
  "paymentSuccessful": "支付成功",
  "paymentPending": "支付待確認",
  "paymentPendingDesc": "您的支付正在處理中，請稍後查看訂單狀態",
  "paymentMethod": "支付方式",
  "paymethods": "支付方式",
  "payCertificate": "支付憑證",
  "直线关系，不能修改推荐": "直線關係，不能修改推薦",
  "tipsRemindsCount": "只能提醒1次喲~",
  "committed": "致力於創業者貸款服務",
  "mediumOpinion": "中評",
  "sort": "種類",
  "重复提交": "重複提交",
  "Reapply": "重新申請",
  "register": "註冊",
  "signUp": "註冊",
  "registerSuccess": "註冊成功",
  "转账币种不能为空": "轉賬幣種不能為空",
  "转账数量不能小于等于0": "轉賬數量不能小於等於0",
  "orderStatus": "狀態",
  "orderState": "狀態",
  "状态不能小于0": "狀態不能小於0",
  "状态不是整数": "狀態不是整數",
  "资金密码必须6-12位": "資金密碼必須為6-12位",
  "资金密码不符合设定": "資金密碼不符合要求",
  "资金密码不能为空": "資金密碼不能為空",
  "资金密码错误": "資金密碼錯誤",
  "资金密码长度不符合设定": "資金密碼長度不符合要求",
  "complex": "綜合",
  "totalOf": "總計",
  "totalPrice": "總價",
  "homeBannertips3": "最高",
  "creditReview": "最快一小時通過審核，審核通過立即下款。",
  "yesterday": "昨天",
  "binance": "Binance",
  "huobi": "Huobi",
  "validatorIpRule": "IP格式不正確",
  "metaMask": "MetaMask",
  "footTip": "{name} 2024 版權所有",
  "footTips": "{name} Limited 作為信貸經紀人 (713206)獲得金融行為監管局的授權和監管，並專門與貸方 Home Retail Group CardServices Limited 合作，以 {name} Financial Services的身份進行交易，{name} Financial Services獲得金融行為監管局的授權和監管以提供信貸(716148)。 Home Retail GroupCard Services Limited 註冊於英國 (04007072)，地址為 Avebury, 489-499Avebury Boulevard, Milton Keynes, United Kingdom。 MK9 2NW。",
  "footdec": "{name}全球站的用戶來自全球{num}個國家，使用{coin}進行結算。 {coin}是一種無國界的交易方式，可以在全球範圍內實現即時低成本交易，無需等待，沒有國際費用。",
  "okx": "okx",
  "UID不能为空": "UID不能為空",
  recommendclass: "推薦分類",
  "滑动验证": "拖動滑塊完成驗證",
  "客户端下载":
    "下載客戶端",
  "最多上传9张图片": "最多上傳9張圖片",
  "提现方式": 
    "提現方式",
  "账号注销": "注銷賬號",
  "确定注销": "注銷賬號",
  "您的账号": "您的賬號",
  "为什么要离开": "為什麼要離開",
  "您还有余额,不能注销账号": "您還有餘額，不能注銷賬號!",
  "请输入注销理由": "請輸入注銷理由",
  "您确认要注销吗?": "您確認要注銷嗎?",
  "App下载(买家端)": "App下載(買家端)",
  "App下载(卖家端)": "App下載(賣家端)",
  "我再考虑下": "我再考慮下",
  "同意注销": "同意注銷",
  "注销成功": "注銷成功",
  "最多包含10位小数": "最多包含10位小數",
  "加密货币": "加密貨幣",
  "银行卡": "銀行卡",
  "充值币种": "充值幣種",
  "企业电话":
    "企業電話",
    "职业机会":
    "職業機會",
  "充值金额": "充值金額",
  "长时间未付款，系统自动取消订单": "長時間未付款，系統自動取消訂單",
  '参数缺失': '參數缺失',
  '充值数量必填': '充值數量必填',
  "充值金额不得小于": "充值金額不得小於",
  "充值金额不得大于": "充值金額不得大於",
  "请先选择币种": "請先選擇幣種",
  "开户行": "開戶行",
  "请输入开户行名称": "請輸入開戶行名稱",
  "银行卡号": "銀行卡號",
  "请输入银行卡号": "請輸入銀行卡號",
  "点击去支付": "點擊去支付",
  "企业证明": "企業證明",
  footTipTikTok:'CoveBuy ©️2024 版權所有',
  "cancelInfo":"警告！請謹慎操作註銷賬戶，如果您不再使用該賬號，可點擊【同意註銷】，註銷後可能幾天內無法註冊。" ,
  TikTokFoot:'CoveBuy商城是CoveBuy與亞洲最大的批發貿易公司阿里巴巴合作建立的全球短視頻社交平台。 是一家全球性電商平台，在全球擁有三個自營智能倉庫，分別位於加拿大多倫多、洛杉磯、日本千葉。 該應用程序中銷售的產品包括來自日本、韓國、中國和其他亞洲國家的熱門產品。 目前總數已突破5萬，並持續快速增長。',
  "betaBannerText": "網站公測中，請勿下單"
};
